var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { grey1 } from '../../styles/colors';
import Typography from '../typography/index.react';
import { createTheadStyle, createTrStyle, createTdStyle, createThStyle, createTableStyle } from './createStyle';

var StatelessTable = function StatelessTable(_a) {
  var _b = _a.items,
      items = _b === void 0 ? [] : _b,
      _c = _a.columns,
      columns = _c === void 0 ? [] : _c,
      className = _a.className,
      theadClassname = _a.theadClassname,
      trHeadClassname = _a.trHeadClassname,
      _d = _a.setTrClassname,
      setTrClassname = _d === void 0 ? function () {
    return '';
  } : _d,
      thClassname = _a.thClassname,
      tdClassName = _a.tdClassName,
      _e = _a.rowKey,
      rowKey = _e === void 0 ? 'id' : _e,
      props = __rest(_a, ["items", "columns", "className", "theadClassname", "trHeadClassname", "setTrClassname", "thClassname", "tdClassName", "rowKey"]);

  return React.createElement("table", __assign({
    className: createTableStyle({
      className: className
    })
  }, props), React.createElement("thead", {
    className: createTheadStyle({
      className: theadClassname
    })
  }, React.createElement("tr", {
    className: createTrStyle({
      className: trHeadClassname
    })
  }, columns.map(function (col, i) {
    return React.createElement("th", {
      key: i,
      className: createThStyle({
        width: col.width,
        className: thClassname
      })
    }, col.label);
  }))), React.createElement("tbody", null, items.map(function (item, j) {
    return React.createElement("tr", {
      key: item[rowKey] || j,
      className: createTrStyle({
        className: setTrClassname(j)
      })
    }, columns.map(function (col, i) {
      return React.createElement("td", {
        key: i,
        className: createTdStyle({
          width: col.width,
          className: tdClassName
        }),
        "data-testid": col.dataTestId
      }, React.createElement(Typography, {
        className: "header-label",
        type: "caption",
        style: {
          color: grey1
        }
      }, col.label), col.render ? col.render(item, j) : col.field && React.createElement(Typography, {
        type: "caption"
      }, item[col.field]));
    }));
  })));
};

export default StatelessTable;